<script lang="ts">
  import { onMount } from "svelte";
  import { WidgetInstance } from "friendly-challenge";

  export let siteKey: string;
  export let solution: string;
  export let language: string = "en";

  let friendlyContainer: HTMLDivElement;

  function done(sln: string) {
    solution = sln;
  }

  function error(error: any) {
    console.error(error);
  }

  onMount(() => {
    const widget = new WidgetInstance(friendlyContainer, {
      startMode: "focus",
      doneCallback: done,
      errorCallback: error,
    });

    return () => {
      widget.destroy();
    };
  });
</script>

<div
  bind:this={friendlyContainer}
  class="frc-captcha"
  data-sitekey={siteKey}
  data-lang={language}
/>

<style lang="scss">
  .frc-captcha {
    box-sizing: border-box;

    min-width: 270px;
    height: 60px;

    border-radius: 3px;

    border: none;

    font-size: 18px;
    line-height: 40px;

    text-align: center;

    background: #ffffff;
  }
</style>
